import { xhrFetch } from "@origin-digital/daxi";
import { logger } from "@origin-digital/reporting-client";

const autocompletePath = "/api/kb/v2/autoComplete";
const searchPath = "/api/kb/v1/search";

type ItemSegment = {
  text: string;
};

type SearchResponseItem = {
  segments: ItemSegment[];
  id: string;
};

export type SearchResult = {
  id: string;
  text: string;
};

interface ISearchResponse {
  resultCount: number;
  results: SearchResponseItem[];
}

const joinItemSegments = (segments: ItemSegment[]): string => {
  return segments
    .map((segment) => segment.text)
    .join(" ")
    .replace(/\s+(\?|!)+/g, "$1");
};

const mapResponseToSearchResult = (
  items: SearchResponseItem[]
): SearchResult[] => {
  return items.map(({ id, segments }) => ({
    id,
    text: joinItemSegments(segments),
  }));
};

export const search = async (
  host: string,
  query: string,
  sid?: string
): Promise<SearchResult[]> => {
  try {
    const url = `${host}${autocompletePath}?sid=${sid}&text=${query}`;
    const { data } = await xhrFetch<ISearchResponse>(encodeURI(url), {
      includeCommonHeaders: false,
    });
    if (data && data.resultCount) {
      return mapResponseToSearchResult(data.results);
    }
  } catch (error) {
    logger.error("error fetching search results", error);
  }
  return [];
};

export const trackSearch = (
  host: string,
  query: string,
  visitorToken: string,
  sid?: string
): void => {
  const url = `${host}${searchPath}?sid=${sid}&text=${query}&src=Search&visitorToken=${visitorToken}`;
  xhrFetch<ISearchResponse>(encodeURI(url), {
    includeCommonHeaders: false,
  }).catch((error) => {
    logger.error("Error tracking search", error);
  });
};
